import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { SetupImplementService } from '../../../setup-implement/setup-implement.service';
import { GenericIdName } from '../../../setup-implement/setup-implement.model';
import { EquipmentDetailsService } from '../../equipment-details.service';
import { ImplementSortOrderForUser, ImplementSortOrder } from '../../equipment-details.model';
import { FilterImplementParams } from '../../../favourite-dialog/favourite-dialog-modal';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-implement-sort',
  templateUrl: './implement-sort.component.html',
  styleUrls: ['./implement-sort.component.scss']
})
export class ImplementSortComponent implements OnInit {

  
  implementList: GenericIdName[] = [];
  implementIds: number
  filteredImplementList: ImplementSortOrder[] = [];
  filteredList: FilterImplementParams[] = [];
  constructor(public dialogRef: MatDialogRef<ImplementSortComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _implementService: SetupImplementService,
    public _equipment: EquipmentDetailsService,
    public toastr: NotificationsService, vcr: ViewContainerRef) {
    
  }

  ngOnInit() {
    if (this.data != null) {

      this._equipment.GetImplementSortOrderforUser(this.data.equipmentId).subscribe(res => {
        this.filteredImplementList = res;

        this._implementService.GetImplementsOnEquipment(this.data.equipmentId).subscribe(r => {
          this.implementList = r;

          this.loadFilteredImplementList();
        });
      });
    }
  }

  loadFilteredImplementList() {

      this.filteredList = [];
      this.implementList.map(x => {
        let obj = {
          Id: 0,
          Name: "",
          Check: false
        };
        let isChecked = false;
        obj.Id = x.Id;
        obj.Name = x.Name;
        obj.Check = isChecked
        
        let pos: number = -1;
        if (this.filteredImplementList) {
          this.filteredImplementList.map(y => {
            if (y.Id == x.Id) {
              pos = y.Position;
              if (pos > this.implementList.length) {
                pos = -1;
              }
              return
            }
          })
        }
        if (pos < this.implementList.length) {
          if (pos > -1) {
            this.filteredList[pos] = (obj)
          }
          else {
            if (pos == -1) {
              this.filteredList.push(obj)
            } else {
              this.filteredList.push(obj)
            }
          }
        } else {
          if (pos > this.implementList.length) {

          } else {
            this.filteredList.push(obj)
          }
        }
      });
    
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }




  saveChanges() {
    var params: ImplementSortOrderForUser = {
      EquipmentId: this.data.equipmentId,
      ImplementSortOrder: this.filteredList
    }
    this._equipment.SaveImplementSortOrder(params).subscribe(result => {
      if (result > 0) {
        this.toastr.success("Saved, Sucessfully");
        this.dialogRef.close();
      }
      else {
        this.toastr.error("Changes not saved.")
      }

    })
  }




  /////////////////////////////////
  ///SORT IMPLEMENTS/////
  ///////////////////////////////
  public down(event, item) {
    let index = this.filteredList.indexOf(item);
    if (index != this.filteredList.length - 1) {

      this.array_move(this.filteredList, index, index + 1)
    }

  }

  public up(event, item) {
    let index = this.filteredList.indexOf(item);
    if (index != 0) {
      this.array_move(this.filteredList, index, index - 1)
    }


  }

  public array_move(arr, old_index, new_index) {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

}
